import { Observable } from "rxjs";
import { Role } from "@planard/@core/entities/role";

export abstract class RoleData {
  abstract list(): Observable<Role[]>;
}
